
const SnsMini = require("./SnsMini")

let sns = xClass("snsMiQuickgame", SnsMini)

sns.prototype.ctor = function() {
    SnsMini.prototype.ctor.call(this);
    this._adDcName = 'mi_video_ad';
    // mini.initAd("30098064");
}

/**
 * 转译广告位
 */
sns.prototype._translateAdPos = function(adPos = "FailAdd1Step", useDefaultId = false) {
    return 'e92fdb7eb9ce8069653086da278b7550';
}

sns.prototype.getOpenKey = function (cb) {
    var self = this
    console.log("snsMiQuickgame getOpenKey start...");

    function onLoginSuccess( openid, sessionid){
        //获取用户信息
        mini.getUserInfo(
            {
                success:function(res){
                    cc.log(["####getSetting: "], res.userInfo)
                    cb && cb({
                        h5game_openid:openid,
                        h5sdk_sessionid:sessionid,
                        avatarUrl: res.userInfo.avatarUrl,
                        nickName: res.userInfo.nickName,
                    })
                },
                fail:function(){
                    console.log("getSetting failed")
                    // showLoginFailModal(null, "getSetting fail")
                    cb && cb({
                        h5game_openid:openid,
                        h5sdk_sessionid:sessionid,
                    })
                }
            }
        )
    }
    mini.login({
        success:(res)=>{
            console.log("snsMiQuickgame login success")
            console.log("snsMiQuickgame login data:"+JSON.stringify(res.data))

            onLoginSuccess(res.data.appAccountId,  res.data.session)
            //token = res.data.token
            // META.tokenid = res.data.token
            // if (cb){
            //     cb({   
            //         h5game_openid: res.data.appAccountId,
            //         h5sdk_sessionid: res.data.session
            //     })
            // }
        },
        fail:(res)=>{
            console.log("snsMiQuickgame login failed")
        }
    })


    return
}

sns.prototype.onLoginFinish = function(openid, sessionid){
    console.log("[####]mi login finish openid:"+openid+" sess:"+sessionid)
    if (openid && sessionid){
        META.user.openid = openid
        META.user.sessionid = sessionid
        //cc.UserDefault.getInstance().setStringForKey("h5game_openid", openid)
        //cc.UserDefault.getInstance().setStringForKey("h5sdk_sessionid", sessionid)
    }else{
        console.log("[####]mi login finish failed no openid or sessionid")
    }

}
sns.prototype.openUrl = function () {
    // 微信不能跳转
}

sns.prototype.hideKeyboard = function () {
    // 微信不能跳转
    mini.hideKeyboard()
}


sns.prototype.share = function (textId, platform, title, imageUrl, _link, callback) {
    
}

sns.prototype.popBack = function () {
    mini.exitMiniProgram({})
}

sns.prototype.alert = function (content, onClickOk) {
    mini.showModal({
        showCancel: false,
        content: content,
        success: onClickOk
    })
}

sns.prototype.drawDataToImg = function (bgpath, info, callback) {

}

sns.prototype.showGridAd = function(config){
    console.warn("not support grid ad");
}

/**
 * 显示插屏广告用
 */
sns.prototype.setNeedShowInterstitialAdName = function(name, flag) {
    if (!this.needShowInterstitialAdName){
        this.needShowInterstitialAdName = [];
    }
    this.needShowInterstitialAdName[name] = flag;
}

sns.prototype.getNeedShowInterstitialAdName = function(name) {
    cc.log(this.needShowInterstitialAdName)
    if (!this.needShowInterstitialAdName){
        this.needShowInterstitialAdName = [];
    }
    return this.needShowInterstitialAdName[name];
}

module.exports = sns